
import { Component, Inject, OnInit, Renderer2, DOCUMENT, OnDestroy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { FCMService } from './services/fcm.service';
import { environment } from '../environments/environment';
import { getApps, initializeApp } from '@angular/fire/app';
import { PermissionService } from './services/permission.service';
import { NgxSpinnerModule } from 'ngx-spinner';
import { Subscription } from 'rxjs';
import { OfflineSyncService } from '@services/offline-sync.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, TranslateModule, NgxSpinnerModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'Dentalab';
  currentLanguage = 'ar';
  subscription$ = new Subscription();
  constructor(
    private translate: TranslateService,
    private renderer: Renderer2,
    private fcmService: FCMService,
    private permissionsService: PermissionService,
    @Inject(DOCUMENT) private document: Document,
     private offlineSync: OfflineSyncService, 
  ) {
    this.permissionsService.loadPermissions();
    const localStorage = this.document.defaultView?.localStorage;
    if (localStorage) {
      const storedLang = localStorage.getItem('language');
      const defaultLang = storedLang || 'ar';
      translate.setDefaultLang(defaultLang);
      translate.use(defaultLang);
      localStorage.setItem('language', defaultLang);
      this.currentLanguage = defaultLang;
    }
    this.subscription$.add(
      this.translate.onLangChange.subscribe(event => {
        this.changeFontPerLang(event.lang);
      })
    );
  }

  ngOnInit() {
    this.offlineSync.init();
    // Ensure Firebase is initialized
    if (!getApps().length) {
      initializeApp(environment.firebase);
    }

    // Now it's safe to use Firebase messaging
    this.fcmService.initializeFCM();
  }

  ngOnDestroy(): void {
    this.subscription$.unsubscribe();
  }

  private changeFontPerLang(lang: string) {
    this.currentLanguage = lang;
    if (this.currentLanguage === 'ar') {
      this.document.body.style.fontFamily = '\'Tajawal\', sans-serif';
      this.renderer.addClass(this.document.body, 'lang-ar');
      this.renderer.removeClass(this.document.body, 'lang-en');
    }
    if (this.currentLanguage === 'en') {
      this.document.body.style.fontFamily = '\'Manrope\', sans-serif';
      this.renderer.addClass(this.document.body, 'lang-en');
      this.renderer.removeClass(this.document.body, 'lang-ar');
    }
  }
}
